module.exports = __webpack_public_path__ + "static/img/jinan5.192bbe00.jpg";